import {
  TKwikUIProgressSegmentedSize,
  VKwikUIProgressSegmentedSize
} from "./progress-segmented.definitions";

export const isValidKeyValue = (key: string, value: any): boolean => {
  const isNumber = (x: number) => typeof x === "number";
  const isStringArray = (x: string | string[]) =>
    typeof x === "string" || Array.isArray(x);

  const methods = {
    colors: isStringArray,
    max: isNumber,
    size: (x: TKwikUIProgressSegmentedSize) =>
      VKwikUIProgressSegmentedSize.includes(x),
    value: isNumber
  };

  return methods[key] && methods[key](value);
};
